import { Record } from 'react-admin';
import { Db } from './types';

const names = ['掘削'];

export const generateWorkTypes = (db: Db): Record[] => {
    return Array.from(Array(names.length).keys()).map(i => {
        const createdAt = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);
        return {
            id: i + 1,
            name: names[i],
            createdAt: createdAt,
            updatedAt: createdAt,
        };
    });
};
